import { Button } from "react-bootstrap";
import {
  getRankingDriverName,
  getRankingTeamName,
  getRankingTeamNumber,
} from "../../utils/ranking.utils";

const RankingsTable = ({
  rankings = [],
  canManage = false,
  onEditSnapshot,
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th style={{ width: 90 }}>Position</th>
            <th style={{ minWidth: 160 }}>Team name</th>
            <th style={{ width: 100 }}>Team #</th>
            <th style={{ minWidth: 140 }}>Driver</th>
            <th style={{ minWidth: 120 }}>Total time</th>
            <th style={{ minWidth: 120 }}>Total penalty</th>
            <th style={{ width: 90 }}>Points</th>
            {canManage ? (
              <th className="text-center" style={{ width: 100 }}>
                Actions
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {rankings.map((entry, index) => {
            const id = entry._id || entry.id || `${index}-${entry.position}`;
            return (
              <tr key={id}>
                <td>{entry.position ?? "-"}</td>
                <td>{getRankingTeamName(entry)}</td>
                <td>{getRankingTeamNumber(entry)}</td>
                <td>{getRankingDriverName(entry)}</td>
                <td>{entry.total_time || "-"}</td>
                <td>{entry.total_penalty || "-"}</td>
                <td>
                  {entry.points === 0 || entry.points ? entry.points : "-"}
                </td>
                {canManage ? (
                  <td className="text-center">
                    <Button
                      type="button"
                      variant="link"
                      className="p-0"
                      onClick={() => onEditSnapshot?.(entry)}
                    >
                      Edit
                    </Button>
                  </td>
                ) : null}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RankingsTable;
